import { alpha } from "@mui/material/styles";

const COLUNAS = "64px repeat(24, minmax(0, 1fr)) 32px";

const styles = (theme) => ({
	container: {
		width: "100%",
		borderRadius: "10px",
		p: "18px 20px",
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
	},
	linhaCabecalho: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		gap: 1,
	},
	cabecalho: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1.5,
	},
	caption: {
		color: theme.palette.text.secondary,
	},
	itemLegenda: {
		display: "flex",
		alignItems: "center",
		gap: "6px",
	},
	quadradoLegenda: (cor) => ({
		width: "10px",
		height: "10px",
		borderRadius: "2px",
		backgroundColor: cor,
	}),
	skeleton: {
		width: "100%",
		height: "200px",
		borderRadius: "8px",
	},
	grade: {
		display: "flex",
		flexDirection: "column",
		gap: "3px",
		overflowX: "auto",
		overflowY: "hidden",
	},
	linhaGrade: {
		display: "grid",
		gridTemplateColumns: COLUNAS,
		gap: "3px",
		alignItems: "center",
		minWidth: "640px",
	},
	rotuloHora: {
		color: theme.palette.text.secondary,
		fontSize: "0.62rem",
		fontVariantNumeric: "tabular-nums",
	},
	rotuloDia: (hoje) => ({
		color: hoje ? theme.palette.text.primary : theme.palette.text.secondary,
		whiteSpace: "nowrap",
	}),
	// Um incidente: cor translúcida; dois ou mais: cor cheia.
	celula: (cor, varios) => ({
		height: "22px",
		borderRadius: "4px",
		backgroundColor: varios ? cor : alpha(cor, 0.6),
		cursor: "pointer",
		// Realce por dentro da célula: não estoura a grade nem cria scroll.
		"&:hover": {
			boxShadow: `inset 0 0 0 2px ${theme.palette.text.primary}`,
		},
	}),
	celulaVazia: (futuro) => ({
		height: "22px",
		borderRadius: "4px",
		backgroundColor: futuro ? "transparent" : theme.palette.action.hover,
		border: futuro ? `1px dashed ${theme.palette.divider}` : "none",
		boxSizing: "border-box",
	}),
	totalDia: {
		color: theme.palette.text.secondary,
		textAlign: "right",
		fontVariantNumeric: "tabular-nums",
	},
	tooltipTitulo: {
		display: "block",
		fontWeight: 700,
	},
	tooltipLinha: {
		display: "block",
	},
});

export default styles;
